import dinnerIcon from "../../assets/icons/romantic-dinner.png";
import wineIcon from "../../assets/icons/wine.png";
import seatsIcon from "../../assets/icons/sitting.png";
import premiumIcon from "../../assets/icons/paristocratic.png";
export const EVENT = {
  id: "event-001",
  title: "French Wine Gala Dinner",
  description:
    "An elegant evening of curated French wines paired with a five-course dinner, hosted by La Chaîne des Rôtisseurs — Bailliage National du Vietnam.",
  date: "18 October 2026",
  day: "Saturday",
  checkin_time: "07:00 PM",
  venue: "Rex Hotel Ballroom",
  venue_city: "Ho Chi Minh City",
  dress_code: "Black Tie",
  member_price: 120,
  guest_price: 150,
  currency: "$",
  highlights: [
    {
      icon: dinnerIcon,
      label: "5-Course Dinner",
      sub: "Exquisite French cuisine",
    },
    {
      icon: wineIcon,
      label: "Fine French Wines",
      sub: "Handpicked premium selections",
    },
    { icon: seatsIcon, label: "120 Seats Only", sub: "An intimate experience" },
    {
      icon: premiumIcon,
      label: "Prestigious Event",
      sub: "By La Chaîne des Rôtisseurs",
    },
  ],
};

export const BANK_DETAILS = {
  accountName: "La Chaine des Rotisseurs - Bailliage National du Vietnam",
  bankName: "Replace with Bank Name",
  bankAddress: "Replace with Branch Address, Ho Chi Minh City, Vietnam",
  accountNumberUSD: "Replace with USD account number",
  accountNumberEUR: "Replace with EUR account number",
  swiftCode: "Replace with SWIFT / BIC code",
  iban: "Replace with IBAN (if applicable)",
};

export const USD_TO_EUR_RATE = 0.92;
